import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { isEmptyBlock } from '../../types/api/Block';
import { ProcessMembershipsBlock, isProcessMembershipsBlock } from '../../_blocks/ProcessMemberships';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type ProcessMembershipsWidget = WidgetShape<[ProcessMembershipsBlock], WidgetType.processMemberships>;

/**
 * ProcessMemberships Widget used in PersonalProfile Page.
 */
export function ProcessMembershipsWidget({ blocks, elementType, ...headerProps }: ProcessMembershipsWidget) {
  const { t } = useSonTranslation('ConnectedProcesses');

  const processMembershipsBlock = blocks.find(isProcessMembershipsBlock);

  if (processMembershipsBlock && isEmptyBlock(processMembershipsBlock)) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader {...headerProps} widgetType={elementType} icon={Icons.PROCESS2} title={t('widgetTitle')}>
      {processMembershipsBlock && <ProcessMembershipsBlock {...processMembershipsBlock} />}
    </DefaultWidgetWithHeader>
  );
}
